module.exports = __webpack_public_path__ + "static/media/star-primary.c9921f01.svg";